import React from "react";
import {observer} from "mobx-react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlayersStatisticsTableRowMemberRowViewModel} from "../../../../domain/yard/lineups/players-statistics/tables/rows/member/players-statistics.table.row.member-row.view-model";
import {BoxScoresWidgetTableStatsCells} from "./box-scores-widget.table-stats.cells";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";

class BoxScoresWidgetTableStatsRowsProps extends BaseProps {
  rows: Array<PlayersStatisticsTableRowMemberRowViewModel>;
  showAllStats: Boolean;
  isGroupedColumn: Boolean;
}

export const BoxScoresWidgetTableStatsRows = observer((({rows, showAllStats, isGroupedColumn}: BoxScoresWidgetTableStatsRowsProps) => {
  return (
    <>
      {
        rows.map((row: PlayersStatisticsTableRowMemberRowViewModel) =>
          <BoxScoresWidgetTableStatsCells
            className={classnames(styles.table_cell, styles.table_body)}
            values={row.values}
            rowNum={row.num}
            emptyCell={row.emptyCellValue}
            showAllStats={showAllStats}
            shouldRenderEmptyState={row.shouldRenderDidNotPlay}
            emptyStateText={row.didNotPlayReason}
            key={row.num}
            isGroupedColumn={isGroupedColumn}
          />)
      }
    </>
  )
}));
